import castArray from 'lodash/castArray';
import T from 'prop-types';
import React from 'react';
import { Translation, useProductCodes } from '../context';
import { renderMarkdown } from './renderMarkdown';

const MarkdownTranslation = ({
  noBottomMargin,
  absolutePath = null,
  ariaSuffixLabel = '',
  currentFormValuePath = null,
  fallbackAbsolutePath = null,
  fallbackPath = null,
  fallbackValue = null,
  formValues = {},
  mappedComponentsProps = {},
  path = null,
  marginBottom = 0,
  ...props
}) => {
  const productCodes = useProductCodes();

  return (
    <Translation
      absolutePath={absolutePath}
      fallbackAbsolutePath={fallbackAbsolutePath}
      fallbackPath={fallbackPath}
      fallbackValue={fallbackValue}
      marginBottom={marginBottom}
      path={path}
    >
      {(translation, translationPath) =>
        renderMarkdown(
          translation,
          {
            ...formValues,
            ...productCodes,
            ...props,
          },
          {
            mappedComponentsProps,
            currentFormValuePath,
            translationPath: castArray(translationPath).join('-'),
            ariaSuffixLabel,
            noBottomMargin,
          }
        )
      }
    </Translation>
  );
};

MarkdownTranslation.propTypes = {
  absolutePath: T.string,
  ariaSuffixLabel: T.string,
  currentFormValuePath: T.string,
  fallbackAbsolutePath: T.string,
  fallbackPath: T.string,
  fallbackValue: T.oneOfType([T.string, T.object]),
  formValues: T.object,
  mappedComponentsProps: T.object,
  path: T.string,
  noBottomMargin: T.bool,
  marginBottom: T.number,
};

export default MarkdownTranslation;
